import { ModuleService } from '@module/module.service';
import { HttpErrorResponse } from '@angular/common/http';
import { ROLES, OS, DEVICE, EMPTY, getNumber } from '@base/utils';
import { IUser, User, IErrorResponse, IDeviceInfo } from '@interfaces';
import { Role } from '@models';
import { Injectable } from '@angular/core';
import { Resolve, Router } from '@angular/router';

import { CompanyService } from '@base/company/company.service';
import { ICompany } from '@base/company/company.structures';
import { AppService } from '@base/app.service';
import { RoleService } from '@base/role/role.service';
import * as jwt_decode from 'jwt-decode';
import { UserService } from '@base/user/user.service';
import { ExceptionService } from '@base/exceptions.service';
import { WorkbookService } from '@workbook/workbook.service';
import { environment } from '@environments/environment';

import { of, } from 'rxjs';
import { concatMap, } from 'rxjs/operators';
import { GroupService } from '@base/group/group.service';
import { TagService } from '@tag/tag.service';

const CUSTOMERS_QUERY_PARAMS = {
  // search: ROLES.CUSTOMER,
  ordering: ['-updated_at', ],
};

export interface IHomeDataSet {
  token: string;
  user: IUser;
  company: ICompany;
}

@Injectable()
export class HomeResolver implements Resolve<IHomeDataSet> {
  private dataSet: IHomeDataSet;
  private user: IUser;
  private token: string;
  private company: ICompany = null;

  constructor(
    private companyService: CompanyService,
    private mainService: AppService,
    private roleService: RoleService,
    private router: Router,
    private userService: UserService,
    private exceptionService: ExceptionService,
    private moduleService: ModuleService,
    private workbookService: WorkbookService,
    private groupService: GroupService,
    private tagService: TagService,
  ) {
    this.user = new User();
  }

  setCompanies(queryParams: object = null) {
    const role: Role = this.user.role || EMPTY;

    if (role !== EMPTY) {
      const filterCompanies = (role.code === ROLES.CUSTOMER || role.code === ROLES.ANALYST);
      const user: IUser = (filterCompanies) ? this.user : null;

      this.companyService.getCompanies(user, queryParams);
    } else {
      this.user.role = EMPTY;
    }
  }

  getCustomers() {
    return new Promise((resolve, reject) => {
      if (this.user.role['code'] === ROLES.ANALYST) {
        // cargar solo los clientes que puede ver el analista...
        this.userService.getUsers(
          CUSTOMERS_QUERY_PARAMS, ROLES.CUSTOMER,
          { user: this.user, endpoint: 'customers' }
        );
      }

      resolve(true);
    });
  }

  liftTableauData() {
    /*
      cargar todos los datos en segundo plano(in background)
      solo cuando NO sea un CLIENTE el que se este logueando
    */
    return new Promise((resolve, reject) => {
      if (this.user.role['code'] !== ROLES.CUSTOMER) {
        // los modulos que van a aparecer en el menu...
        this.moduleService.getModules();

        /*
          modulo de tableau... sincronizar empresas, workbooks y grupos!
          ejecutar secuencialmente las peticiones en Tableau Server...
          --> concatMap <--
        */

        const deviceInfo: IDeviceInfo = this.mainService.getDeviceInfo();
        const executeSync = (deviceInfo.device !== DEVICE.IPAD &&
          deviceInfo.device !== DEVICE.IPHONE);

        if (executeSync) {
          const tableauRequests = of(
            this.companyService.synchronizeTableau(),
            this.workbookService.synchronizeTableau(),
            this.groupService.synchronizeTableau(),
            this.userService.synchronizeTableau()
          );
          tableauRequests.pipe(
            concatMap((r: any) => r),
          ).subscribe(
            (res) => {
              // console.log('respuesta ==>', res);
            },
            (err: HttpErrorResponse) => {
              console.log(err);
              const error: IErrorResponse = this.exceptionService.errorHandling(err);
            }
          );
        }
      }
      resolve(true);
    });
  }

  async resolve() {
    if (typeof this.mainService.temp['company'] !== 'undefined') {
      this.company = this.mainService.temp['company'];
    } else {
      this.company = JSON.parse(localStorage.getItem('company'));
    }

    this.dataSet = {
      token: '',
      user: new User(),
      company: this.company,
    };
    this.token = localStorage.getItem('token');

    if (this.token !== null) {
      this.user = jwt_decode(this.token);

      if (this.user.role !== EMPTY) {
        this.mainService.setToken(this.token);
        this.user.id = getNumber(this.user['user_id']);
        delete this.user['user_id'];
        this.dataSet.token = this.token;

        // setear los roles para compararlos con el del usuario logueado...
        const roles = await this.roleService.getRoles().toPromise().catch(
          (err: HttpErrorResponse) => {
            console.log(err.message);
            const error: IErrorResponse = this.exceptionService.errorHandling(err);
          }
        );

        if (typeof roles !== 'undefined') {
          this.mainService.roles = roles;
          this.user.role = roles.filter((role: Role) => role.id === this.user.role)[0];
          this.mainService.setCurrentUser(this.user);
          // this.setCompanies({ ordering: ['-updated_at', ] });

          // Activa el refrescamiento automatico del token solo cuando esta en Produccion
          if (environment.production) { this.mainService.refreshToken(); }

          if (this.user.role['code'] !== ROLES.CUSTOMER) {
            // precargar los datos
            // this.userService.getUsers({ search: ROLES.ADMIN, ordering: ['-updated_at', ], }, ROLES.ADMIN);
            // this.userService.getUsers({ search: ROLES.LEADER, ordering: ['-updated_at', ], }, ROLES.LEADER);
            // this.userService.getUsers({ search: ROLES.ANALYST, ordering: ['-updated_at', ], }, ROLES.ANALYST);
            // this.userService.getUsers({ search: ROLES.CUSTOMER, ordering: ['-updated_at', ], }, ROLES.CUSTOMER);
          }

          this.tagService.loadTags();

          // ejecutar los asincronos...
          return Promise.all([
            // this.getCustomers(),
            this.liftTableauData(),
          ]).then(
            (responses) => {
              this.dataSet = {
                ...this.dataSet,
                user: this.user,
              };
              return this.dataSet;
            }
          );
        } else {
          console.warn('servidor desconectado');
          this.router.navigate(['/']);
        }
      } else {
        localStorage.removeItem('token');
        this.router.navigate(['']);
      }
    } else {
      console.warn('no existe sesion activa en este equipo');
      this.router.navigate(['']);
    }
  }
}
